import {JourneyTrack} from '../journey-track';
import {TrackTypes} from '../model/track-types';
import {TrackInfo} from '../model/track-info';
import {TrackActionResult} from "../model/track-action-result";
import {ContaIonDataParse} from "../conta-ion/util/conta-ion-data-parse";
import {CacheService} from "../../../comunicator-native/cache/v2/cache.service";
import { OriginInvestAction } from './actions/origin-action';
import { OriginIncomeInvestAction } from './actions/origin-income-action';
import { CompanyAction } from './actions/company-action';
import { trackDefaultIncomeBasic } from './util/track-default-income';

export class BasicProfessionalTrack extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('origin-income', ['professional-data', 'origin-income'], undefined, {
      undefined,
      actionName: ActionList.ActionOrigin
  }),
    new TrackInfo('profession', ['professional-data', 'profession'], undefined, {
      undefined,
      actionName: ActionList.ActionIncome
  }),
    new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj'], undefined, {
      undefined,
      actionName: ActionList.actionCompany
    }),
    ...trackDefaultIncomeBasic
  ];

  track = [];

  constructor(private cacheNativeService: CacheService) {
    super();
    this.track = this.originalTracks;
  }

  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC;
  }

  async loadData(){
    // MobileMockData.executeMockCall(500);
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    localStorage.setItem('cache-native', JSON.stringify(data));
    return Promise.resolve(data);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    switch (actionName) {
      case ActionList.ActionOrigin:
          return OriginInvestAction.execute(data, this.track, true);
      case ActionList.ActionIncome:
          return OriginIncomeInvestAction.execute(data, this.track);
      case ActionList.actionCompany:
          return CompanyAction.execute(data);
    }
  }

  isUncoupled() {
    return true;
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionOrigin = 'actionOrigin',
  ActionIncome = 'actionIncome',
  actionCompany = 'actionCompany'
}